import { Logger } from "lib";
import ActionBarOps from "views/components/Editor/actionbar/ActionBarOps";

const EditorResizeOps = {
  startResizing({ pageId }) {
    Logger.info("Editor.startResizing called");

    const {
      htmlElements: { canvasBackground }
    } = this.state;
    /* we disable the scrolling while resizing */
    canvasBackground.style.overflow = "hidden";

    const selectedItemsUpdated = this.props.selectedItems
      //we deselected the items from another page
      .filter(item => item.pageId === pageId)
      .map(selectedItem => ({
        ...selectedItem,
        preview: {
          opacity: 0
        }
      }));
    this.props.updateContextState({
      selectedItems: selectedItemsUpdated,
      context: {},
      isResizing: true
    });
    this.props.updateActionBarState({
      ...this.state.actionbar,
      buttonActive: null
    });
  },

  finishResizing({
    anchorPoint,
    offset,
    scale,
    zoom,
    handlerCoordinateName,
    differenceFromInitialOffset,
    dragItem
  }) {
    Logger.info("Editor.finishResizing called");

    const {
      htmlElements: { canvasBackground }
    } = this.state;
    const { designData, selectedItems } = this.props;

    /* because we disable the scrolling while resizing */
    canvasBackground.style.overflow = "scroll";

    const selectedItemsUpdated = selectedItems.map(selectedItem => ({
      ...selectedItem,
      preview: {}
    }));

    // Snapshot pre-resize elements so matchElementInDesign's content fallback
    // resolves correctly on siblings after resizing (source-side post-resize
    // fields can diverge from siblings for value/src/imageInstructions keys
    // the fallback uses).
    const originalElements = selectedItems.reduce((acc, item) => {
      const element = designData.elements[item.itemId];
      if (element) acc[item.itemId] = element;
      return acc;
    }, {});

    const designDataUpdated = designData.resizeElements({
      dragItem,
      selectedItems,
      anchorPoint,
      offset,
      scale,
      zoom,
      handlerInitialPosition: dragItem.handlerInitialPosition,
      scaleDirection: handlerCoordinateName,
      differenceFromInitialOffset
    });

    // Enqueue the geometry change for "Update Collection" propagation using
    // the post-resize geometry pulled from designDataUpdated. Short-circuits
    // on non-collection documents.
    const selectedElementsData = selectedItems
      .map(item => {
        const originalElement = originalElements[item.itemId];
        const resizedElement = designDataUpdated.elements[item.itemId];
        if (!originalElement || !resizedElement || !resizedElement.type) {
          return null;
        }
        const newGeometry = {
          left: resizedElement.left,
          top: resizedElement.top,
          width: resizedElement.width,
          height: resizedElement.height
        };
        if (typeof resizedElement.scale === "number") {
          newGeometry.scale = resizedElement.scale;
        }
        return {
          uniqueId: resizedElement.uniqueId || item.itemId,
          pageId: item.pageId,
          type: resizedElement.type,
          originalElement,
          newGeometry
        };
      })
      .filter(Boolean);

    if (selectedElementsData.length) {
      ActionBarOps.enqueueGeometryPropagation({
        designData,
        currentPageId: selectedElementsData[0].pageId,
        selectedElementsData,
        collectionDesigns: this.props.collectionDesigns,
        addActionToPropagationQueue: this.props.addActionToPropagationQueue
      });
    }

    this.props.updateContextState({
      selectedItems: selectedItemsUpdated,
      context: {},
      isResizing: false
    });
    this.props.onSave(designDataUpdated, {});
  },

  onToggleImageFitToFrame(elementId, containerProps) {
    Logger.info("EditorResizeOps.onToggleImageFitToFrame called");
    const { designData } = containerProps;

    let updatedDesignData;
    updatedDesignData = designData.toggleFitToFrame({
      elementId
    });

    containerProps.updateContextState({ designData: updatedDesignData });
    containerProps.onSave(updatedDesignData, {});
  },

  onSetImageFitToFrame(elementId, isFitToFrame, containerProps) {
    Logger.info("EditorResizeOps.onSetImageFitToFrame called");
    const { designData } = containerProps;

    let updatedDesignData;
    updatedDesignData = designData.setFitToFrame(elementId, isFitToFrame);

    // setFitToFrame returns undefined for unsupported element types
    if (!updatedDesignData) return;

    // Return if no update has occured
    if (
      designData.elements[elementId].fitToFrame ===
      updatedDesignData.elements[elementId].fitToFrame
    ) {
      return;
    }

    containerProps.updateContextState({ designData: updatedDesignData });
    containerProps.onSave(updatedDesignData, {});
  }
};

export default EditorResizeOps;
